/**
 * Generic modal wrapper with header bar, body and footer slots.
 * Matches the existing styling used across MerchantManagementTab modals.
 */
export default function MerchantModal({
  open, onClose, title, subtitle, headerStyle, headerBg = '#051C2C',
  children, footer, size = 'lg', testid,
}) {
  if (!open) return null;
  const sizeClass = {
    sm: 'max-w-sm', md: 'max-w-md', lg: 'max-w-lg', xl: 'max-w-2xl', '2xl': 'max-w-3xl',
  }[size] || 'max-w-lg';

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid={testid}
    >
      <div
        className={`bg-white rounded-xl w-full ${sizeClass} max-h-[90vh] overflow-y-auto`}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="px-6 py-4 border-b" style={headerStyle || { backgroundColor: headerBg }}>
            <h3 className="text-lg font-bold text-white">{title}</h3>
            {subtitle && <p className="text-xs text-blue-300">{subtitle}</p>}
          </div>
        )}
        <div className="p-6">{children}</div>
        {footer && <div className="px-6 py-4 border-t bg-gray-50 flex justify-end gap-3">{footer}</div>}
      </div>
    </div>
  );
}
